import React from "react";
import TransactionItem from "./TransactionItem";

const MonthDivider = ({ month }) => {
    return (
        <h2 className=" text-white" style={{ fontSize: 13 }}>
            {month}
        </h2>
    );
};

export default function TransactionList({ transactions }) {
    // Group transactions by month
    const groupedTransactions = {};

    transactions.forEach((transaction) => {
        if (!groupedTransactions[transaction.month]) {
            groupedTransactions[transaction.month] = [];
        }
        groupedTransactions[transaction.month].push(transaction);
    });

    return (
        <div>
            {Object.entries(groupedTransactions).map(
                ([month, monthTransactions]) => (
                    <div key={month} className="mb-4">
                        <MonthDivider month={month} />
                        <div className="mt-3">
                            {monthTransactions.map((transaction) => (
                                <TransactionItem
                                    key={transaction.id}
                                    transaction={transaction}
                                />
                            ))}
                        </div>
                    </div>
                )
            )}
        </div>
    );
}
